import { Mesh } from "@babylonjs/core/Meshes/mesh";
import { CreatePolygon } from "@babylonjs/core/Meshes/Builders/polygonBuilder";
import { Texture as BJSTexture } from "@babylonjs/core/Materials/Textures/texture";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { VertexBuffer } from "@babylonjs/core/Buffers/buffer";
import * as MyEarcut from "earcut";
import { ElementGeometry } from './ElementGeometry';
import { Util } from '../../utils/Util';
import { PbrMaterial } from '@egr/wcf/modules/core/mdl';
import { PropertyChangedResult, PropertyValue, StringProperty } from '@egr/wcf/modules/core/prop';
import { ShadowGenerator } from '@egr/wcf/modules/core/rendering/ShadowGenerator';
export class BackgroundImage extends ElementGeometry {
    constructor(pRoomManager, pElement) {
        super(pRoomManager, pElement);
        this.mRoomElement = pElement;
        this.mRoomManager = pRoomManager;
        this.mImageBase64 = "";
        this.mHeight = 2;
        this.mWidth = 3;
        this.mImageProportional = true;
        this.mPoints = new Array();
        this.mPoints.push(new Vector3(0, 0, 0));
        this.mPoints.push(new Vector3(0, 0, 0));
        this.mPoints.push(new Vector3(0, 0, 0));
        this.mPoints.push(new Vector3(0, 0, 0));
        this.mDepth = 0.1;
        this.mArea = 0;
        this.mCenter = Vector3.Zero();
        this.mminPoint = Vector3.Zero();
        this.mmaxPoint = Vector3.Zero();
        this.mRoomElement.Params.ElementPoints = new Array();
        this.mRoomElement.Params.ElementPoints = this.mPoints;
        this.mRoomElement.Params.material = this.mRoomElement.material;
        this.mRoomElement.Params.materialColor = this.getInitialParams().color;
        //texture
        this.mTexture = new BJSTexture("", this.mScene, undefined, false, BJSTexture.BILINEAR_SAMPLINGMODE, null, null, undefined, true);
        this.mTexture.uScale = 1;
        this.mTexture.vScale = 1;
        this.mMaterial = new PbrMaterial("room:backgroundimageMaterial", this.mMatManager);
        //this.mMaterial.emissiveColor = Color3.White();
        //this.mMaterial.emissiveIntensity=0;
        //this.mMaterial.disableLighting = false;
        this.mMaterial.albedoTexture = this.mTexture;
        this.mMaterial.metallic = 0;
        this.mMaterial.roughness = 1;
        this.mMaterial.backFaceCulling = true;
        this.mMaterial.freeze();
        this.mElementParams = {};
        this.mElementParams.privacyFilter = false;
        this.mElementParams.blindVisible = false;
        this.mElementParams.blindDepth = 0.07;
        this.mElementParams.blindOpeningAngle = 60;
        this.mElementParams.blindOpeningWidth = 0;
        this.mElementParams.ColumnCount = 2;
        this.mLoaded = false;
    }
    getType() {
        return ("BackgroundImage");
    }
    setMesh(pMesh) {
        this.mArea = Util.calcMeshArea(pMesh) * 0.25;
    }
    getPoints() {
        return this.mPoints;
    }
    get width() {
        return (this.mWidth);
    }
    get depth() {
        return this.mDepth;
    }
    center() {
        return this.mCenter;
    }
    get minPoint() {
        return (this.mminPoint);
    }
    get maxPoint() {
        return (this.mmaxPoint);
    }
    get2dMesh() {
        return this.m2dMesh;
    }
    showInteractors(pShow) {
        if (this.mInteractors != null)
            this.mInteractors.showInteractors(pShow);
    }
    getInitialParams() {
        let tParams = {};
        tParams.width = this.mWidth;
        tParams.height = this.mHeight;
        tParams.depth = 0.1;
        tParams.floorOffset = 0.0;
        tParams.color = "#ffffff";
        tParams.imageProportional = this.mImageProportional;
        return (tParams);
    }
    get Area() {
        return (this.mArea);
    }
    get Perimeter() {
        return (this.mPerimeter);
    }
    getparent() {
        return (this.mParent);
    }
    async create2dGeometry(pParent) {
        this.checkSizeChanging();
        this.checkInitialPoints();
        let tmesh = this.createImagePlane(pParent);
        if (tmesh != null) {
            this.prepare2dMesh(tmesh);
            this.mRoomElement.setMesh2d(tmesh);
        }
    }
    create3dGeometry(pParent) {
        let tmesh = this.createImagePlane(pParent);
        if (tmesh != null) {
            this.mRoomElement.Params.MeshVertices = tmesh.getVerticesData(VertexBuffer.PositionKind);
            this.prepare3dMesh(tmesh);
            this.mRoomElement.setMesh3d(tmesh);
        }
    }
    getProperties() {
        let tProperties = new Array();
        //image
        let tImageProp = new StringProperty(this.mRoomElement, BackgroundImage.PROP_KEY_BACKGROUNDIMAGE, this.mRoomManager.resources.propertyBackgroundImage);
        tImageProp.getValue = () => new PropertyValue("");
        tImageProp.setValue = (pValue) => {
            let tValue = StringProperty.ConvertValueToString(pValue);
            if (tValue != null && this.mRoomElement.setImageURL(tValue))
                return (Promise.resolve(PropertyChangedResult.Value));
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        tImageProp.visible = false;
        tProperties.push(tImageProp);
        let tYesNoChoices = new Array();
        for (let tYesNo of this.mRoomManager._YesNo)
            tYesNoChoices.push(this.mRoomManager._getYesNoPropValue(tYesNo));
        // //proportional image size
        // let tProportionalProp = new BoolProperty(this.mRoomElement, BackgroundImage.PROP_KEY_IMAGEPROPORTIONAL,
        //     this.mRoomManager.resources.propertyProportional);
        // tProportionalProp.choiceList = true;
        // tProportionalProp.getChoices = () => Promise.resolve(tYesNoChoices);
        // tProportionalProp.getValue = () => this.mRoomManager._getYesNoPropValue(this.mRoomElement.imageProportional);
        // tProportionalProp.setValue = (pValue) =>
        // {
        //     if (pValue != null) {
        //         let tisProp = BoolProperty.ConvertValueToBool(pValue)!;
        //         this.mRoomElement.setImageProportional(tisProp);
        //         return (Promise.resolve(PropertyChangedResult.Value));
        //     }
        //     return (Promise.resolve(PropertyChangedResult.Nothing));
        // };
        // tProperties.push(tProportionalProp);
        return (tProperties);
    }
    serializeIOData() {
        return (this.mRoomElement.Params);
    }
    loadIOData(pData, pContext) {
        let tParams = pData;
        let tPoints = new Array();
        for (let tEP of tParams.ElementPoints) {
            let tP = new Vector3(0, 0, 0);
            tP.x = tEP.x;
            tP.z = tEP.z;
            tPoints.push(tP);
        }
        if (this.mRoomElement.materialId !== "") {
            let tMat = this.mMatManager.getMaterial(this.mRoomElement.materialId);
            if (tMat != null) {
                this.mMaterial = tMat;
                this.mLoaded = true;
            }
        }
        this.setPoints(tPoints);
    }
    resetPoints() {
        this.mPoints = [];
        this.mPoints.push(new Vector3(0, 0, 0));
        this.mPoints.push(new Vector3(0, 0, 0));
        this.mPoints.push(new Vector3(0, 0, 0));
        this.mPoints.push(new Vector3(0, 0, 0));
    }
    setPoints(pPoints) {
        this.mPoints = [];
        let tP1 = pPoints[0];
        let tP2 = pPoints[1];
        let tP3 = pPoints[2];
        let tP4 = pPoints[3];
        this.mPoints.push(tP1);
        this.mPoints.push(tP2);
        this.mPoints.push(tP3);
        this.mPoints.push(tP4);
        this.mRoomElement.Params.ElementPoints = this.mPoints;
        this.calcSize();
        this.mRoomElement.setMeshMaterial1();
        this.mRoomElement.setClosedPolygon(true);
    }
    onImgLoad(pHTML, pEvent) {
        //
    }
    checkInitialPoints() {
        if ((this.mPoints[0].x === 0) && (this.mPoints[3].x === 0)) {
            let tW = this.mRoomElement.width * 0.5;
            let tH = this.mRoomElement.height;
            this.mPoints[0].x = -tW;
            this.mPoints[0].y = 0;
            this.mPoints[0].z = tH;
            this.mPoints[1].x = -tW;
            this.mPoints[1].y = 0;
            this.mPoints[1].z = 0;
            this.mPoints[2].x = tW;
            this.mPoints[2].y = 0;
            this.mPoints[2].z = 0;
            this.mPoints[3].x = tW;
            this.mPoints[3].y = 0;
            this.mPoints[3].z = tH;
            this.setPoints(this.mPoints);
        }
    }
    checkSizeChanging() {
        if (this.mRoomElement.SizeChanging) {
            this.mPoints = [];
            let tW = this.mRoomElement.width;
            let tH = this.mRoomElement.height;
            this.mPoints.push(new Vector3(-tW * 0.5, 0, tH));
            this.mPoints.push(new Vector3(-tW * 0.5, 0, 0));
            this.mPoints.push(new Vector3(tW * 0.5, 0, 0));
            this.mPoints.push(new Vector3(tW * 0.5, 0, tH));
            this.setPoints(this.mPoints);
        }
    }
    async getBase64String(pImgURL) {
        let tImageDataUrl = await new Promise((resolve, reject) => {
            let tImage = new Image();
            tImage.crossOrigin = "Anonymous";
            tImage.onload = () => {
                let canvas = document.createElement("canvas");
                canvas.width = tImage.naturalWidth;
                canvas.height = tImage.naturalHeight;
                let tcanContext = canvas.getContext("2d");
                if (tcanContext != null) {
                    tcanContext.drawImage(tImage, 0, 0);
                    resolve(canvas.toDataURL("image/png"));
                }
            };
            tImage.onerror = () => {
                reject();
            };
            tImage.src = pImgURL;
        });
        return (tImageDataUrl);
    }
    calcSize() {
        if (this.mPoints.length === 0)
            return;
        let tminX = this.mPoints[0].x;
        let tminY = this.mPoints[0].y;
        let tmaxX = this.mPoints[0].x;
        let tmaxY = this.mPoints[0].y;
        for (let tPoint of this.mPoints) {
            tminX = Math.min(tPoint.x, tminX);
            tmaxX = Math.max(tPoint.x, tmaxX);
            tminY = Math.min(tPoint.z, tminY);
            tmaxY = Math.max(tPoint.z, tmaxY);
        }
        this.mWidth = Vector3.Distance(this.mRoomElement.Params.ElementPoints[0], this.mRoomElement.Params.ElementPoints[3]);
        this.mHeight = Vector3.Distance(this.mRoomElement.Params.ElementPoints[0], this.mRoomElement.Params.ElementPoints[1]);
        this.mRoomElement.setWidth(this.mWidth, false);
        this.mRoomElement.setHeight(this.mHeight, false);
        this.mminPoint = new Vector3(tminX, -this.depth * 0.5, tminY);
        this.mmaxPoint = new Vector3(tmaxX, this.depth * 0.5, tmaxY);
        this.mCenter.x = tmaxX - (tmaxX - tminX) * 0.5;
        this.mCenter.z = tmaxY - (tmaxY - tminY) * 0.5;
    }
    createImagePlane(pParent) {
        if (this.mPoints.length === 0)
            return (null);
        this.mTexture.uScale = 1;
        this.mTexture.vScale = 1;
        let tLines = new Array();
        this.mRoomElement.Params.ElementPoints = [];
        this.mRoomElement.Params.ElementPoints = this.mPoints;
        let tP1 = this.mRoomElement.Params.ElementPoints[0];
        let tP2 = this.mRoomElement.Params.ElementPoints[1];
        let tP3 = this.mRoomElement.Params.ElementPoints[2];
        let tP4 = this.mRoomElement.Params.ElementPoints[3];
        tLines.push([tP1, tP2]);
        tLines.push([tP2, tP3]);
        tLines.push([tP3, tP4]);
        tLines.push([tP4, tP1]);
        let tpolygon = CreatePolygon("", {
            shape: this.mRoomElement.Params.ElementPoints,
            sideOrientation: Mesh.DOUBLESIDE
        }, this.mScene, MyEarcut);
        ShadowGenerator.disableMeshShadow(tpolygon);
        tpolygon.material = this.mRoomElement.localMaterial;
        tpolygon.isPickable = true;
        tpolygon.parent = pParent;
        this.calcSize();
        return (tpolygon);
    }
}
//// private ///////////////////////////////////////////////////////////////////////////////
BackgroundImage.PROP_KEY_BACKGROUNDIMAGE = "room:RoomElement:backgroundimage";
BackgroundImage.PROP_KEY_IMAGEPROPORTIONAL = "room:RoomElement:imageproportional";
